<script setup lang="ts">
import type { SuggestionListItemProps } from "~/components/hd/SuggestionList.vue";
import type { FieldDefinition } from "~/models/Automation";
import type { FormField } from "~/models/FormField";

const props =
    defineProps<SuggestionListItemProps<FieldDefinition, any, FormField>>();
</script>

<template>
    <div class="flex items-start gap-2 w-full flex-1">
        <BadgeFieldType :label="`${context.item.metadata.position + 1}.`" variant="badge"
            :type="context.item.metadata.type" :sub-type="context.item.metadata.sub_type" />
        <span>{{
            context.item.label
                .replace(context.item.metadata.label ?? "", "")
                .replace(`${context.item.metadata.position}.`, "")
                .replace(`${context.item.metadata.position + 1}.`, "")
                .replaceAll(" ", " ")
                .replaceAll(" ", " ")
        }}</span>
    </div>
</template>
